import { t } from "@lingui/macro";
import { CaretDown, UploadSimple } from "@phosphor-icons/react";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  KeyboardShortcut,
} from "@reactive-resume/ui";

import { trackUploadClicked } from "@/client/libs/analytics";
import {
  ImportType,
  type ImportDialogPayloadItem,
} from "@/client/pages/dashboard/resumes/_dialogs/import";
import { useDialog } from "@/client/stores/dialog";

import { BaseListItem } from "./base-item";

export const UploadResumeListItem = () => {
  const { open: openUpload } = useDialog("upload");
  const { open: openImport } = useDialog<ImportDialogPayloadItem>("import");

  return (
    <BaseListItem
      start={<UploadSimple size={18} />}
      title={
        <>
          <span>{t`Upload a resume`}</span>
          {/* eslint-disable-next-line lingui/no-unlocalized-strings */}
          <KeyboardShortcut className="ml-2">^I</KeyboardShortcut>
        </>
      }
      description={t`PDF, DOCX, TXT, or import JSON / LinkedIn`}
      onClick={() => {
        trackUploadClicked();
        openUpload("create");
      }}
      end={
        <DropdownMenu>
          <DropdownMenuTrigger asChild className="aspect-square">
            <Button
              size="icon"
              variant="ghost"
              type="button"
              aria-label={t`Import options`}
              onClick={(event) => {
                event.stopPropagation();
              }}
            >
              <CaretDown />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="min-w-[220px]">
            <DropdownMenuItem
              onClick={(event) => {
                event.stopPropagation();
                openImport("create", {
                  id: "import",
                  item: { initialImportType: ImportType["json-resume-json"] },
                });
              }}
            >
              {t`JSON Resume (.json)`}
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={(event) => {
                event.stopPropagation();
                openImport("create", { id: "import" });
              }}
            >
              {t`Other import sources…`}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      }
    />
  );
};
